interface Props {
  width?: string;
  height?: string;
}

const DnaHelix = ({ width = '20', height = '26' }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 26"
      fill="none"
      style={{ display: 'block' }}
    >
      <path
        d="M5.64 24.765c-.615-2.295-.635-4.284-.06-5.968.575-1.684 1.51-3.479 2.804-5.383-2.073-1.002-3.78-2.088-5.12-3.26C1.924 8.985.947 7.252.332 4.956l-.067-.247a.99.99 0 0 1 .097-.782.997.997 0 0 1 .628-.474.99.99 0 0 1 .783.096c.242.14.4.35.473.629l.067.247a9.678 9.678 0 0 0 .315.978l9.805-2.628a9.066 9.066 0 0 0-.216-1.004l-.066-.247a.99.99 0 0 1 .096-.782.997.997 0 0 1 .63-.474.99.99 0 0 1 .782.096c.242.14.4.35.473.63l.066.247c.615 2.294.635 4.284.06 5.969-.574 1.685-1.509 3.479-2.804 5.382 2.073 1.001 3.78 2.088 5.12 3.26 1.34 1.171 2.318 2.904 2.932 5.198l.067.248a.993.993 0 0 1-.096.782.988.988 0 0 1-.63.474.998.998 0 0 1-.781-.097.99.99 0 0 1-.474-.628l-.066-.248a9.234 9.234 0 0 0-.315-.977L7.405 23.23a10.194 10.194 0 0 0 .216 1.004l.066.248a.993.993 0 0 1-.096.782.988.988 0 0 1-.63.474.997.997 0 0 1-.78-.097.99.99 0 0 1-.475-.628l-.066-.248zM5.076 8.992l7.032-1.884c.13-.371.233-.735.306-1.09.073-.356.124-.742.154-1.157L3.555 7.276c.229.328.465.632.708.913.243.28.514.548.813.803zm4.498 2.723a52.6 52.6 0 0 0 .74-1.101c.239-.365.46-.725.666-1.08l-3.714.994c.356.206.728.407 1.117.604.389.196.786.39 1.191.583zm-.716 4.756 3.714-.995a22.801 22.801 0 0 0-1.117-.603c-.388-.197-.786-.39-1.19-.583-.256.369-.503.736-.741 1.1-.238.365-.46.726-.666 1.081zM7.27 21.143l9.014-2.415a11.08 11.08 0 0 0-.708-.911 7.755 7.755 0 0 0-.814-.805L7.73 18.898a8.255 8.255 0 0 0-.46 2.246z"
        fill="#4B3221"
      />
    </svg>
  );
};

export default DnaHelix;
